import * as process from 'process';

const blacklist = [
  'FAST_REFRESH',
  'WDS_SOCKET_HOST',
  'WDS_SOCKET_PATH',
  'WDS_SOCKET_PORT',
];

interface IConfiguration {
  readonly ENV: string;
  readonly VERSION: string;
  readonly API_URL: string;

  readonly CLIENT_SECRET: string;

  readonly [key: string]: any;
}

const builder = (dictionary: Record<string, any>): IConfiguration => {
  const configuration: any = {};
  Object.entries(dictionary).forEach(([key, value]) => {
    if (blacklist.includes(key)) return;
    configuration[key.replace(/^(REACT_APP_|NODE_)/ig, '')] = value;
  });

  return Object.seal(configuration);
};

export default builder(process.env);
